<template>
  <div class="content-box" v-if="data.length">
    <div v-for="item in data" :key="item.nodeId" class="level-1">
      <div class="level-1-text" :class="item.qrcodeTag === qrCodeTag ? 'active' : ''" :id="item.qrcodeTag">
        {{
          item.name }}
        <img v-if="item.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" />
      </div>
      <template v-if="item.childNodes && item.childNodes.length">
        <div class="level-2" v-for="child in item.childNodes" :key="child.nodeId">
          <div class="level-2-text" :id="child.qrcodeTag" :class="child.qrcodeTag === qrCodeTag ? 'active' : ''">{{
            child.name }}<img v-if="child.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" /></div>
          <template v-if="child.childNodes && child.childNodes.length">
            <div class="level-3" v-for="grandchild in child.childNodes" :key="grandchild.nodeId">
              <div class="level-3-text" :id="grandchild.qrcodeTag"
                :class="grandchild.qrcodeTag === qrCodeTag ? 'active' : ''">{{ grandchild.name }}<img
                  <img v-if="grandchild.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" /></div>
              <template v-if="grandchild.childNodes && grandchild.childNodes.length">
                <div class="level-3" v-for="greatgrandchild in grandchild.childNodes" :key="greatgrandchild.nodeId">
                  <div class="level-3-text" :id="greatgrandchild.qrcodeTag"
                    :class="greatgrandchild.qrcodeTag === qrCodeTag ? 'active' : ''">{{
                      greatgrandchild.name }}<img v-if="greatgrandchild.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" /></div>
                  <template v-if="greatgrandchild.resourceList && greatgrandchild.resourceList.length">
                    <div v-for="resource in greatgrandchild.resourceList" :key="resource.resourceId"
                      class="resources-item" @click="handleClick(resource)" :id="resource.qrcodeTag"
                      :class="resource.qrcodeTag === qrCodeTag ? 'active' : ''">
                      <img :src="iconMap[resource.type]" alt="">
                      <span class="resource-text">{{ resource.name }}</span>
                      <img v-if="resource.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" />
                    </div>
                  </template>
                </div>
              </template>
              <template v-if="grandchild.resourceList && grandchild.resourceList.length">
                <div v-for="resource in grandchild.resourceList" :key="resource.resourceId" class="resources-item"
                  @click="handleClick(resource)" :id="resource.qrcodeTag"
                  :class="resource.qrcodeTag === qrCodeTag ? 'active' : ''">
                  <img :src="iconMap[resource.type]" alt="">
                  <span class="resource-text">{{ resource.name }}</span>
                  <img v-if="resource.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" />
                </div>
              </template>
            </div>
          </template>
          <template v-if="child.resourceList && child.resourceList.length">
            <div v-for="resource in child.resourceList" :class="resource.qrcodeTag === qrCodeTag ? 'active' : ''"
              :key="resource.resourceId" class="resources-item" @click="handleClick(resource)" :id="resource.qrcodeTag">
              <img :src="iconMap[resource.type]" alt="">
              <span class="resource-text">{{ resource.name }}</span>
              <img v-if="resource.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" />
            </div>
          </template>
        </div>
      </template>
      <template v-if="item.resourceList && item.resourceList.length">
        <div v-for="resource in item.resourceList" :class="resource.qrcodeTag === qrCodeTag ? 'active' : ''"
          :key="resource.resourceId" :id="resource.qrcodeTag" class="resources-item" @click="handleClick(resource)">
          <img :src="iconMap[resource.type]" alt="">
          <span class="resource-text">{{ resource.name }}</span>
          <img v-if="resource.qrcodeTag === qrCodeTag" src="@/assets/active-icon.png" class="active-icon" alt="" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import videoIcon from "@/assets/video-icon.png";
import audioIcon from "@/assets/audio-icon.png";
import answerIcon from "@/assets/answer-icon.png";

export default {
  name: "ContentBox",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    trackData: {
      type: Object,
      default: () => { },
    },
    qrCodeTag: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iconMap: {
        video: videoIcon,
        audio: audioIcon,
        answer: answerIcon,
      },
    };
  },
  methods: {
    handleClick(resource) {
      const { name, type, code, data } = resource;
      let resourceName = ''
      const query = {}
      if (type === 'video') {
        resourceName = code.replaceAll('<ID>', '').replaceAll('</ID>', '')
        query.videoId = encodeURIComponent(resourceName)
        query.name = name
        query.type = 'video'
        query.resourceName = encodeURIComponent(resourceName)
      }
      if (type === 'audio') {
        sessionStorage.removeItem('audioSrcList');
        resourceName = data[0].content
        query.type = 'audio'
        query.name = name
        query.resourceName = encodeURIComponent(resourceName)
        const audioList = data.filter(v => v.audioUrl).map(v => v.audioUrl)
        sessionStorage.setItem('audioSrcList', JSON.stringify(audioList))
      }
      if (type === 'answer') {
        sessionStorage.removeItem('answerIdList');
        query.type = 'answer'
        sessionStorage.setItem('answerIdList', JSON.stringify(data))
        resourceName = name
        query.resourceName = encodeURIComponent(resourceName)
      }
      ktbj.track('BUTTON_CLICK', { ...this.trackData, buttonName: name, resourceName: resourceName });
      this.$router.push({
        path: '/videoPlayer',
        query
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  padding: 15px 20px;
  background-color: #fff;

  .active {
    color: #37c555 !important;
  }

  .active-icon {
    width: 16px !important;
    height: 20px !important;
  }

  .level-1-text {
    font-weight: 600;
    font-size: 16px;
    color: #141414;
    margin-bottom: 15px;
    position: relative;

    .active-icon {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .level-2 {
    padding-left: 20px;
  }

  .level-2-text {
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    position: relative;
    margin-bottom: 15px;

    .active-icon {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &::before {
      content: "";
      position: absolute;
      left: -20px;
      bottom: 8px;
      width: 14px;
      height: 6px;
      background: #37C555;
      border-radius: 3px;
    }
  }

  .level-3 {
    padding-left: 20px;

    .level-3-text {
      font-weight: 400;
      font-size: 16px;
      color: #141414;
      position: relative;
      margin-bottom: 15px;

      .active-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      &::before {
        content: "";
        position: absolute;
        left: -13px;
        bottom: 8px;
        width: 6px;
        height: 6px;
        background: #37C555;
        border-radius: 3px;
      }
    }
  }

  .resources-item {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #141414;
    margin-bottom: 15px;

    img {
      width: 30px;
      height: 30px;
      margin-right: 6px;
      flex-shrink: 0;
      /* 图片禁止压缩，固定大小 */
    }

    .resource-text {
      flex: 1;
      /* 文字占满剩余宽度 */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
